export interface TrainStationInfo {
    name: string;
    parent?: string;
}

export const trainStationCodeMap = new Map<string, TrainStationInfo>([
    ["STP", { name: "London Saint Pancras" }],
  ]);
  